import React, { Component } from 'react';
import * as ajax from './../../ajax.js';
import * as lang from './../../lang.js';

import PopUpWindow from './../../components/PopUpWindow';
import { Container, Row, Col, Button } from 'react-bootstrap';

import TextInsertField from './../../components/TextInsertField';
import ComboBoxInsertField from './../../components/ComboBoxInsertField';
import NumberInsertField from './../../components/NumberInsertField';
import TextAreaInsertField from './../../components/TextAreaInsertField';


class MunkaBeosztasCimekView extends Component {

    constructor(props) {
        super(props);
        this.state = {
            munkaBeosztasCimek_id: ''
            , munkaBeosztasCimek_munka_beosztas_id: ''
            , munkaBeosztasCimek_ugyfel_id: ''
            , munkaBeosztasCimek_irsz: ''
            , munkaBeosztasCimek_telepules: ''
            , munkaBeosztasCimek_cim: ''
            , munkaBeosztasCimek_megjegyzes: ''

        }


        this.references = [];
        this.references['munkaBeosztasCimek_id'] = React.createRef();
        this.references['munkaBeosztasCimek_munka_beosztas_id'] = React.createRef();
        this.references['munkaBeosztasCimek_ugyfel_id'] = React.createRef();
        this.references['munkaBeosztasCimek_irsz'] = React.createRef();
        this.references['munkaBeosztasCimek_telepules'] = React.createRef();
        this.references['munkaBeosztasCimek_cim'] = React.createRef();
        this.references['munkaBeosztasCimek_megjegyzes'] = React.createRef();


        this.validators = [];
        this.validators['munkaBeosztasCimek_id'] = {fieldName: 'munkaBeosztasCimek_id', dataType: 'INT', value: this.state.munkaBeosztasCimek_id, mandatory: false, min: null, max: null};
        this.validators['munkaBeosztasCimek_munka_beosztas_id'] = {fieldName: 'munkaBeosztasCimek_munka_beosztas_id', dataType: 'INT', value: this.state.munkaBeosztasCimek_munka_beosztas_id, mandatory: false, min: null, max: null};
        this.validators['munkaBeosztasCimek_ugyfel_id'] = {fieldName: 'munkaBeosztasCimek_ugyfel_id', dataType: 'INT', value: this.state.munkaBeosztasCimek_ugyfel_id, mandatory: false, min: null, max: null};
        this.validators['munkaBeosztasCimek_irsz'] = {fieldName: 'munkaBeosztasCimek_irsz', dataType: 'VARCHAR', value: this.state.munkaBeosztasCimek_irsz, mandatory: false, min: null, max: null};
        this.validators['munkaBeosztasCimek_telepules'] = {fieldName: 'munkaBeosztasCimek_telepules', dataType: 'VARCHAR', value: this.state.munkaBeosztasCimek_telepules, mandatory: false, min: null, max: null};
        this.validators['munkaBeosztasCimek_cim'] = {fieldName: 'munkaBeosztasCimek_cim', dataType: 'VARCHAR', value: this.state.munkaBeosztasCimek_cim, mandatory: false, min: null, max: null};
        this.validators['munkaBeosztasCimek_megjegyzes'] = {fieldName: 'munkaBeosztasCimek_megjegyzes', dataType: 'VARCHAR', value: this.state.munkaBeosztasCimek_megjegyzes, mandatory: false, min: null, max: null};


        this.error = false;
        this.msg = "";

        this.load();

    }

    componentDidUpdate(prevProps) {
        if (prevProps.id !== this.props.id) {
            this.load();
        }
    }

    reset = function () {
        this.setState({munkaBeosztasCimek_id: ''
            , munkaBeosztasCimek_munka_beosztas_id: ''
            , munkaBeosztasCimek_ugyfel_id: ''
            , munkaBeosztasCimek_irsz: ''
            , munkaBeosztasCimek_telepules: ''
            , munkaBeosztasCimek_cim: ''
            , munkaBeosztasCimek_megjegyzes: ''
        });
    }

    setBack = function (id, value) {
        this.setState({[id]: value});
    }

    getForm = function () {
        return <Container>
            <Row>
                <Col style={{textAlign: 'left'}}>{lang.getTitleBold('munkaBeosztasCimek_ugyfel_id')}</Col>
                <Col style={{textAlign: 'right'}}>
                <ComboBoxInsertField 
                    id={'munkaBeosztasCimek_ugyfel_id'} 
                    value={this.state.munkaBeosztasCimek_ugyfel_id}  
                    setBack={this.setBack.bind(this)}
                    dataSourceUrl={'modules/MunkaBeosztasCimek/ugyfel_idFormComboInsertData.php'}
                    reference={this.references['munkaBeosztasCimek_ugyfel_id']}
                    editable={false}
                    theme={this.props.theme}
                    />
                </Col>
            </Row>
            <Row>
                <Col style={{textAlign: 'left'}}>{lang.getTitleBold('munkaBeosztasCimek_irsz')}</Col>
                <Col style={{textAlign: 'right'}}>
                <TextInsertField 
                    id={'munkaBeosztasCimek_irsz'} 
                    value={this.state.munkaBeosztasCimek_irsz}  
                    setBack={this.setBack.bind(this)}
                    reference={this.references['munkaBeosztasCimek_irsz']}
                    editable={false}
                    theme={this.props.theme}
                    />
                </Col>
            </Row>
            <Row>
                <Col style={{textAlign: 'left'}}>{lang.getTitleBold('munkaBeosztasCimek_telepules')}</Col>
                <Col style={{textAlign: 'right'}}>
                <TextInsertField 
                    id={'munkaBeosztasCimek_telepules'} 
                    value={this.state.munkaBeosztasCimek_telepules}  
                    setBack={this.setBack.bind(this)}
                    reference={this.references['munkaBeosztasCimek_telepules']}
                    editable={false}
                    theme={this.props.theme}
                    />
                </Col>
            </Row>
            <Row>
                <Col style={{textAlign: 'left'}}>{lang.getTitleBold('munkaBeosztasCimek_cim')}</Col>
                <Col style={{textAlign: 'right'}}>
                <TextInsertField 
                    id={'munkaBeosztasCimek_cim'} 
                    value={this.state.munkaBeosztasCimek_cim}  
                    setBack={this.setBack.bind(this)}
                    reference={this.references['munkaBeosztasCimek_cim']}
                    editable={false}
                    theme={this.props.theme}
                    />
                </Col>
            </Row>
            <Row>
                <Col style={{textAlign: 'left'}}>{lang.getTitleBold('munkaBeosztasCimek_megjegyzes')}</Col>
            </Row>
            <Row>
                <Col style={{textAlign: 'right'}}>
                <TextAreaInsertField 
                    id={'munkaBeosztasCimek_megjegyzes'} 
                    value={this.state.munkaBeosztasCimek_megjegyzes}  
                    setBack={this.setBack.bind(this)}
                    reference={this.references['munkaBeosztasCimek_megjegyzes']}
                    editable={false}   
                    theme={this.props.theme}
                    style={{minWidth:'100%'}}
                    />
                </Col>
            </Row>
        
        </Container>
    }

    closeForm = function () {
        this.reset();
        this.props.closeForm();

    }

    transactionSuccess = function () {
        this.error = false;
        this.msg = lang.getTitleBold('transaction_success');
        this.setState({});
    }

    transactionFail = function (errorStringConstant) {
        this.error = true;
        this.msg = lang.getTitleBold(errorStringConstant);
        this.setState({});
    }

    concatAdditionalParams = function () {
        // var stateClone = JSON.parse(JSON.stringify(this.state));
        if (typeof this.props.additionalParams == 'undefined') {
            return this.state;
        }

        if (this.props.additionalParams == null) {
            return this.state;
        }

        var additionalParams = this.props.additionalParams;
        for (var i = 0; i < additionalParams.length; i++) {
            var additionalParam = additionalParams[i];
            for (const property in additionalParam) {
                this.state[property] = additionalParam[property];
            }
        }
        return this.state;
    }

    load = function () {
        var validator = ajax.Validator();
        var validForm = validator.formValidator(this.references, this.validators, this.state);
        if (validForm == false) {
            return false;
        }
        var self = this;
        try {
            const url = ajax.getUrlBase() + "modules/MunkaBeosztasCimek/munkaBeosztasCimekFormLoader.php";

            return fetch(url, {
                method: "POST",
                headers: new Headers({"Content-Type": "application/json"}),
                body: JSON.stringify({id: this.props.id})
            }).then(response => {
                if (response.ok) {
                    return response.json().then(response => {
                        if (response.success) {
                            this.setState(response.data[0]);
                        } else {
                            self.transactionFail(response.fail);
                        }

                    }).catch(function (jsonError) {
                        
                        if (null == jsonError) {
                            self.transactionFail('Fetch JSON error');
                            console.error("Fetch JSON error:");
                        } else {
                            self.transactionFail("Fetch JSON error:" + String(jsonError));
                            console.error("Fetch JSON error:" + String(jsonError));
                        }
                    });
                } else {
                    
                    self.transactionFail("HTTP status error:", response.statusText);
                    console.error("HTTP status error:", response.statusText);
                }
            }).catch(function (error) {
                
                self.transactionFail("Fetch error:", error);
                console.error("Fetch error:", error);
                if (null == error) {
                    self.transactionFail("Fetch error:");
                    console.error("Fetch error:");
                } else {
                    self.transactionFail("Fetch error:" + String(error));
                    console.error("Fetch error:" + String(error));
                }
            });
        } catch (ex) {
            
            self.transactionFail("Fetch exception:", String(ex));
            console.error("Fetch exception:", String(ex));
        }
    }

    render() {
        var form = this.getForm();
        var className = (this.props.theme == "true") ? "Dark" : "Light";
        return (<PopUpWindow theme={this.props.theme} style={{maxHeight:600}}>
            <div className={'popupWrapper' + className} id="MunkaBeosztasCimekUpdate">
                <div  className={"popupHeader" + className} >
                    <Row>
                        <Col></Col>
                        <Col style={{textAlign: 'center'}}>{lang.getTitleBold('MunkaBeosztasCimekView')}</Col>
                        <Col style={{textAlign: 'right'}}>
                        <Button className={'btn-sm'} variant="danger" onClick={this.closeForm.bind(this)}>{lang.getTitle('close')}</Button>
                        </Col>
                    </Row>
                </div>
                <div  className={"popupBody" + className} >{form}</div>
                <div  className={"popupFooter" + className} >
                    <Row>
                        <Col>
                        <div style={{whiteSpace: 'break-spaces'}}>
                            {this.msg} 
                        </div>
        
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                        <Button className={'btn-sm'} id={'save'} onClick={this.closeForm.bind(this)} variant="success" style={{marginTop: '5px'}}>{lang.getTitle('close')}</Button>&nbsp;&nbsp;&nbsp;      
                        </Col>
                    </Row>
                    <Row>
                        <Col style={{minHeight: '10px'}}>
        
                        </Col>
                    </Row>
        
                </div>
            </div>
        </PopUpWindow>);
    }
}

export default MunkaBeosztasCimekView;

